var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProjectView',{attrs:{"projectId":_vm.projectId,"id":_vm.id,"isPreview":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }